import { axios, handleApiErrors, getToken } from '../helpers'

export default (id, token = getToken()) => {
  const params = { token }

  return axios
    .request({
      url: `workrequests/${id}/accept`,
      method: 'POST',
      params
    })
    .then(handleApiErrors)
}
